export enum PermissionTypeDto {
    Allowed = 'Allowed',
    Blocked = 'Blocked',
}
